import React, { memo } from 'react';
import PropTypes from 'prop-types';
import isNil from 'ramda/src/isNil';
import length from 'ramda/src/length';
import type from 'ramda/src/type';
import * as Instances from '@components/CareerRequiredInstances';
import * as ProgramsList from '@components/LibraryProgramsList';

const CertificationRequirements = ({ className, data, contentLevel }) => {
    const { habits, quotas, trainings, documents } = data[contentLevel];
    const habitsLength = type(habits) === 'Object' ? length(habits.day) + length(habits.week) + length(habits.month) : length(habits);
    return (
        <div className={`cert-requirements ${className}`} key={`level-${contentLevel}`}>
            <div className="required-field pt-2">
                <p className="dsl-b18 text-500">Required Quotas</p>
                {length(quotas) > 0 ? <Instances.QuotasDetail data={quotas} type="template" /> : <p className="dsl-m12 mb-0">No Goals assigned</p>}
            </div>
            <div className="required-field pt-4">
                <p className="dsl-b18 text-500">Required Habits</p>
                {habitsLength > 0 ? <Instances.HabitsDetail data={habits} /> : <p className="dsl-m12 mb-0">No Habits assigned</p>}
            </div>
            <div className="required-field pt-4">
                <p className="dsl-b18 text-500">Required Training</p>
                {!isNil(trainings) && length(trainings.items) > 0 ? <Instances.TrainingsDetail data={trainings.items} /> : <p className="dsl-m12 mb-0">No Learning assigned</p>}
            </div>
            <div className="required-field pt-4 mt-4 border-top">
                <p className="dsl-b18 text-500">Documents:</p>
                {length(documents) > 0 ? <ProgramsList.DocumentList modules={documents} /> : <p className="dsl-m12 mb-0">No documents uploaded yet...</p>}
            </div>
        </div>
    );
};

CertificationRequirements.propTypes = {
    className: PropTypes.string,
    data: PropTypes.any,
};

CertificationRequirements.defaultProps = {
    className: '',
    data: {},
};

export default memo(CertificationRequirements);
